import { Button, Grid, MenuItem, makeStyles } from "@material-ui/core";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { ReactHookFormSelect } from "../../../utils";

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(2),
		borderTop: "1px solid #E0E0E0",
	},
	title: {
		paddingTop: "1rem",
	},
}));

const StatusNotes = (props) => {
	const classes = useStyles();
	const { stateOption, fetchAPI, issues, sendMessages } = props;
	const { handleSubmit, errors, control, clearErrors } = useForm();

	const [addChange, setAddChange] = useState({
		idstatus: "",
	});
	const { idstatus } = addChange;

	const reset = () => {
		setAddChange({
			idstatus: "",
		});
		clearErrors();
	};

	const onSubmitIssue = async () => {
		const dataFetch = {
			...addChange,
			idlayanan: issues?.idlayanan,
			idticket: issues?.idticket,
		};
		let result = await fetchAPI("editStatuNotes", dataFetch);
		if (result.status === "success") {
			sendMessages("notes", { idticket: dataFetch.idticket });
			reset();
		}
		return result;
	};
	return (
		<div className={classes.root}>
			<h3 className={classes.title}>Change Status Task</h3>
			<form onSubmit={handleSubmit(onSubmitIssue)}>
				<ReactHookFormSelect
					id="idstatus"
					// register={register}
					name="idstatus"
					label="STATUS"
					control={control}
					error={errors.idstatus}
					value={idstatus}
					setState={setAddChange}
					state={addChange}
					variant="outlined"
					margin="normal"
					fullWidth
					required
				>
					<MenuItem value="none" disabled selected>
						--Pilih Status--
					</MenuItem>
					{stateOption.optionStatusIssue &&
						stateOption.optionStatusIssue.map((item, i) => (
							<MenuItem key={i} value={item.id}>
								{item.nama}
							</MenuItem>
						))}
				</ReactHookFormSelect>
				<Grid
					style={{
						display: "flex",
						// marginTop: "0.5rem",
						justifyContent: "end",
					}}
				>
					<Button type="submit" variant="contained" color="primary">
						Submit &#10148;
					</Button>
				</Grid>
			</form>
		</div>
	);
};

export default StatusNotes;
